import { Environment } from 'shared/providers/environment.constants';

export const tier = (currentEnv: Environment): string => {
  switch (currentEnv) {
    case Environment.UAT:
      return 'uat';
    case Environment.PROD:
      return 'production';
    default:
      return 'uat';
  }
};
